import React, { Component } from "react";
import CloseButton from "./closeButton";
import "./preferencesPane.scss";

class PreferencesPane extends Component {
  render() {
    return (
      <div className="PreferencesPane">
        <CloseButton />
        <h2>Update Recommendations</h2>
      </div>
    );
  }
}

export default PreferencesPane;
